import { useEffect, useState } from 'react';

import { fetchAuthConfig, resolveAgainstApi } from '../../../api/authConfig';
import { FakeJwtAuthProvider } from '../methods/fakeJwt/FakeJwtAuthProvider';
import { KeycloakAuthProvider } from '../methods/keycloak/KeycloakAuthProvider';
import { SimulatedAuthProvider } from '../methods/simulated/SimulatedAuthProvider';

const isKeycloakEnabled = () =>
  Boolean(process.env.REACT_APP_OIDC_AUTHORITY?.trim());

/* for when no backend answer is available (mock mode, old or
   unreachable backend) — and for unknown methods, which must not
   break this client */
const EnvSelectedAuthProvider = ({ children }) => {
  if (isKeycloakEnabled()) {
    return <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;
  }

  return <SimulatedAuthProvider>{children}</SimulatedAuthProvider>;
};

/* the fitting login method is a property of the backend, not of this
   build — ask it first (src/api/authConfig.js); fake-jwt exists only
   through that answer */
export const AuthProvider = ({ children }) => {
  /* undefined = still asking the backend, null = no usable answer */
  const [authConfig, setAuthConfig] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchAuthConfig().then((config) => {
      if (!cancelled) setAuthConfig(config);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (authConfig === undefined) {
    return null;
  }

  if (authConfig?.method === 'oidc') {
    return (
      <KeycloakAuthProvider authority={authConfig.authority}>
        {children}
      </KeycloakAuthProvider>
    );
  }

  if (authConfig?.method === 'fake-jwt') {
    return (
      <FakeJwtAuthProvider tokenUrl={resolveAgainstApi(authConfig.tokenUrl)}>
        {children}
      </FakeJwtAuthProvider>
    );
  }

  return <EnvSelectedAuthProvider>{children}</EnvSelectedAuthProvider>;
};
